export const ROLE_SET = 'ROLE_SET';